import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'

// Don't import css here, we override in the SCSS in App.vue
//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
